import { PopoverRoot } from "@datamole/wds-component-popover";
import { ReactNode, useState } from "react";

import { MenuContext } from "../menu.context";

type Props = {
    children: ReactNode;
};
const MenuRoot = (props: Props) => {
    const { children } = props;

    const [isOpen, setIsOpen] = useState(false);

    return (
        <MenuContext.Provider value={{ isOpen, setIsOpen }}>
            <PopoverRoot open={isOpen} onOpenChange={setIsOpen}>
                {children}
            </PopoverRoot>
        </MenuContext.Provider>
    );
};
MenuRoot.displayName = "Menu";

export { MenuRoot };
export type { Props as MenuProps };
